import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-cancel-cause',
  templateUrl: './order-line-cancel-cause.component.html',
  styleUrls: ['./order-line-cancel-cause.component.css']
})
export class OrderLineCancelCauseComponent implements OnInit {
    orderLineCauseKeyno;

    public edit?: Edit;

    public saving = false;

    public orderLineCancelCauseLangNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderlinecancelcauselang', gotoParms: () => this.edit!.orderlinecancelcause_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderLineCauseKeyno = this.stateService.getStateParams()['orderlinecancelcause_keyno'];
    }

    private async loadEdit() {
        if (!!this.orderLineCauseKeyno) {
            this.edit = (await this.datatask.Post(3326, { orderlinecancelcause_keyno: this.orderLineCauseKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3327, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    orderlinecancelcause_keyno: string;
    orderlinecancelcause_name: string;
    orderlinecancelcause_note_required: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCancelCause', {
//        templateUrl: 'views/components/views/orderLineCancelCause/orderLineCancelCause.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'orderLineCancelCauseService', function ($stateParams, stateService, translateService, modalService, orderLineCancelCauseService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineCauseKeyno = $stateParams.orderlinecancelcause_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                orderLineCancelCauseLangNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderlinecancelcauselang', { orderlinecancelcause_keyno: vm.model.edit.orderlinecancelcause_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await orderLineCancelCauseService.getOrderLineCancelCause({ orderlinecancelcause_keyno: orderLineCauseKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCancelCauseService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
